<template>
  <el-dialog :title="'添加休假 - ' + technician.name" :visible.sync="dialogVisible" :close-on-click-modal="false"
             :close-on-press-escape="false" @close="dialogFormVisible" width="600px">
    <el-form :model="form" ref="formRef" label-width="100px">
      <el-form-item label="休假类型" prop="leave_type" :rules="[{ required: true, message: '请输入休假类型' }]">
        <el-input v-model="form.leave_type" placeholder="如：事假、病假"></el-input>
      </el-form-item>
      <el-form-item label="休假时间" prop="leave_time_range" :rules="[{ required: true, message: '请选择休假时间' }]">
        <el-date-picker v-model="form.leave_time_range" type="datetimerange" range-separator="至"
                        start-placeholder="开始日期时间" end-placeholder="结束日期时间" value-format="yyyy-MM-dd HH:mm:ss">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="备注" prop="remark">
        <el-input type="textarea" v-model="form.remark"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible">取 消</el-button>
      <el-button type="primary" @click="submitClick" :loading="loading">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import LeaveApi from '@/api/technician/leave.js';

export default {
  name: 'TechnicianLeave',
  props: ['open_add', 'open_leave', 'technician'],
  data() {
    return {
      loading: false,
      dialogVisible: false,
      form: {
        technician_id: 0,
        leave_type: '',
        start_time: '',
        end_time: '',
        remark: '',
        // 辅助字段
        leave_time_range: []
      }
    };
  },
  created() {
    this.dialogVisible = this.open_leave || this.open_add;
    this.form.technician_id = this.technician.id;
  },
  methods: {
    submitClick() {
      let self = this;
      self.$refs.formRef.validate(valid => {
        if (valid) {
          self.loading = true;
          self.form.start_time = self.form.leave_time_range[0];
          self.form.end_time = self.form.leave_time_range[1];
          // 准备提交数据，移除辅助字段
          const { leave_time_range, ...params } = self.form;
          LeaveApi.add(params, true)
            .then((res) => {
              self.loading = false;
              if (res.code === 1) {
                self.$message.success('添加成功');
                self.dialogFormVisible(true);
              }
            })
            .catch(() => {
              self.loading = false;
            });
        }
      });
    },
    dialogFormVisible(isSuccess) {
      this.$emit('closeDialog', { type: isSuccess ? 'success' : 'cancel' });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/technician/leave/Add.vue